import React from "react";
import {Redirect} from 'react-router-dom';
import DatePicker from 'react-datepicker';
import Pagination from "react-js-pagination";
import Swal from 'sweetalert2'
import moment from 'moment';
import {Link} from 'react-router-dom';
import ReactDOM from "react-dom";
import * as Util from "../common/Util";
import * as AppConstant from "../common/AppConstant";
import Errors from "../common/Errors";
import InvalidAccessOrLogin from '../errorsPage/InvalidAccessOrLogin';
/*
var BarChart = require("react-chartjs").Bar;
*/

class Dashboard extends React.Component {

    constructor(params) {
        super(params);
        this.state = {
            list: [],
            blubillingConf: {},
            activeNumber:1,
            lastTenDays:30,
            count:0,
            search:'',
            limit:50,
            apiStatus: {
                isError: false,
                message: ''
            },
            showLoader:false,
            filterPagination: false,
            dashboard: {},
            baseUserList: [],
            statusList: ["SIGNED", "PENDING", "PROCESSING","DRAFT", "CANCELLED"],
            status: '',
            baseUser: '',
            loggedInUser:{},
            createdFrom:null,
            createdTo: null,
            lastUpdatedFrom: null,
            lastUpdatedTo:  null,
            sentFrom:null,
            sentToRecipient:null,
            formatCreatedFrom: null,
            formatCreatedTo: null,
            formatLastUpdatedFrom: null,
            formatLastUpdatedTo: null,
            formatSentFrom: null,
            formatSentToRecipient: null,
            emailTitle: '',
            redirectToForbiddenPage: false
        }
        this.fetchAllSignatureTemplate = this.fetchAllSignatureTemplate.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDeleteSignature = this.handleDeleteSignature.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleSelect = this.handleSelect.bind(this)
        this.handleChangeDatePicker = this.handleChangeDatePicker.bind(this);
        this.clearAllFilters = this.clearAllFilters.bind(this);
        this.fetchDashboard = this.fetchDashboard.bind(this);
    }
    handleChangeDatePicker(name, formattedName, date) {
        this.setState({
            [name]: date
        });
        if(date){
            this.setState({[formattedName]: moment(date).format("YYYY-MM-DD")})
        }else{
            this.setState({[formattedName]: date})
        }
    }
    fetchAllSignatureTemplate(event){
        let activePageNumber = 1;
        if(event !== null && isNaN(event) === true){
            event.preventDefault();
        }else if(event !== null && isNaN(event) === false){
            if(isNaN(parseInt(event + '', 10)) === true){
                activePageNumber = 0;
            }else {
                activePageNumber = (parseInt(event+'', 10)-1);
                this.setState({activeNumber: event});
            }
        }
        console.log(event + "======" + isNaN(event) + "=====" + activePageNumber)
        let url = this.props.api + "/signature?offset=" + activePageNumber + "&limit=" + 50;
        if(AppConstant.validateValue(this.state.status,'S') === true){
            if(url.indexOf("?") > -1)
                url+="&status="+this.state.status
            else{
                url+="?status="+this.state.status
            }
        }
        if(AppConstant.validateValue(this.state.emailTitle,'S') === true){
            if(url.indexOf("?") > -1)
                url+="&emailTitle="+this.state.emailTitle;
            else{
                url+="?emailTitle="+this.state.emailTitle
            }
        }
        if(AppConstant.validateValue(this.state.baseUser,'N') === true) {
            if (url.indexOf("?") > -1)
                url += "&createdBy=" + this.state.baseUser;
            else {
                url += "?createdBy=" + this.state.baseUser;
            }
        }
        if(AppConstant.validateValue(this.state.formatCreatedFrom,'S') === true) {
            if (url.indexOf("?") > -1)
                url += "&createdFrom=" + this.state.formatCreatedFrom;
            else {
                url += "?createdFrom=" + this.state.formatCreatedFrom;
            }
        }
        if(AppConstant.validateValue(this.state.formatCreatedTo,'S') === true) {
            if (url.indexOf("?") > -1)
                url += "&createdTo=" + this.state.formatCreatedTo;
            else {
                url += "?createdTo=" + this.state.formatCreatedTo;
            }
        }
        if(AppConstant.validateValue(this.state.formatLastUpdatedFrom,'S') === true) {
            if (url.indexOf("?") > -1)
                url += "&lastUpdatedFrom=" + this.state.formatLastUpdatedFrom;
            else {
                url += "?lastUpdatedFrom=" + this.state.formatLastUpdatedFrom;
            }
        }
        if(AppConstant.validateValue(this.state.formatLastUpdatedTo,'S') === true) {
            if (url.indexOf("?") > -1)
                url += "&lastUpdatedTo=" + this.state.formatLastUpdatedTo;
            else {
                url += "?lastUpdatedTo=" + this.state.formatLastUpdatedTo;
            }
        }
        if(AppConstant.validateValue(this.state.formatSentFrom,'S') === true) {
            if (url.indexOf("?") > -1)
                url += "&sentFrom=" + this.state.formatSentFrom;
            else {
                url += "?sentFrom=" + this.state.formatSentFrom;
            }
        }
        if(AppConstant.validateValue(this.state.formatSentToRecipient,'S') === true) {
            if (url.indexOf("?") > -1)
                url += "&sentToRecipient=" + this.state.formatSentToRecipient;
            else {
                url += "?sentToRecipient=" + this.state.formatSentToRecipient;
            }
        }
        if(AppConstant.validateValue(this.state.search,'S') === true) {
            if (url.indexOf("?") > -1)
                url += "&search=" + this.state.search;
            else {
                url += "?search=" + this.state.search;
            }
            this.setState({showLoader:false});
        }else{
            this.setState({showLoader:true});
        }
        fetch(url,{
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                console.log(json);
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.setState({showLoader: false});
                    this.props.onLogoutClick(json.message);
                } else if (json.httpCode === 403 && json.isError === true && json.message === "Forbidden") {
                    this.setState({showLoader: false, redirectToForbiddenPage: true});
                } else {
                    if (isNaN(event) === false) {
                        this.setState({list: json.content, activeNumber: event, count: json.totalElements})
                        this.setState({showLoader: false});
                    } else {
                        this.setState({list: json.content, count: json.totalElements})
                        this.setState({showLoader: false});
                    }
                }
            }).catch(error => {
            this.setState({showLoader:false});
            console.log(error);
        });
    }
    fetchDashboard(event){
        let activePageNumber = 1;
        if(event !== null && isNaN(event) === true){
            event.preventDefault();
        }else if(event !== null && isNaN(event) === false){
            if(isNaN(parseInt(event + '', 10)) === true){
                activePageNumber = 0;
            }else {
                activePageNumber = (parseInt(event+'', 10)-1);
                this.setState({activeNumber: event});
            }
        }
        console.log(event + "======" + isNaN(event) + "=====" + activePageNumber)
        this.setState({showLoader:true});
        let url = this.props.api + "/dashboard?offset=" + activePageNumber + "&limit=" + 50;
        fetch(url,{
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-AUTH-TOKEN': this.props.jwtToken
            }
        })
            .then(response => response.json())
            .then(json => {
                console.log(json);
                if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                    this.setState({showLoader: false});
                    this.props.onLogoutClick(json.message);
                }else if(json.httpCode === 403 && json.isError === true && json.message === "Forbidden"){
                    this.setState({showLoader:false, redirectToForbiddenPage:true});
                } else {
                    if (isNaN(event) === false) {
                        this.setState({list: json.eSignatureRequests.content, activeNumber: event, count: json.eSignatureRequests.totalElements})
                        this.setState({showLoader: false});
                    } else {
                        this.setState({list: json.eSignatureRequests.content, count: json.eSignatureRequests.totalElements})
                        this.setState({showLoader: false});
                    }
                    if(json.staffsPage) {
                        this.setState({baseUserList: json.staffsPage.content})
                    }
                    if(json.blubillingConfiguration){
                        this.setState({blubillingConf : json.blubillingConfiguration});
                    }
                    if(json.loggedInUser){
                        this.setState({loggedInUser: json.loggedInUser, baseUser: (json.loggedInUser ? json.loggedInUser.id : '')});
                    }
                }
            }).catch(error => {
            this.setState({showLoader:false});
            console.error(error);
        });
    }
    handleChange(event) {
        console.log("event "+event);
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        console.log("name  "+target.name);
        this.setState({search:""})
        this.setState({[name]: value});
    }
    handleSearch(event){
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({[name]: value},function(){
            if(value && value.length >= 3){
                this.fetchAllSignatureTemplate(1)
            }
        });
        this.clearAllFilters(event)
    }
    handleSelect(event) {
        const target = event.target;
        const value = target.value;
        console.log(value);
        this.setState({lastTenDays: value})
        let url = this.props.api + "/signature/search";
        url += "?lastTenDays=" + value + "&limit=" + this.state.limit + "&offset=0"
        this.fetchTemplates(url, true)
    }
    handleResendEmail(esignId){
        let url = this.props.api+'/signature/resend/'+esignId;
        console.log("url--- "+url);
        Swal.fire({
            title: 'Are you sure?',
            text: 'This will resend the Esignature Request to mentioned recipients',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Re-Send it!',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                this.setState({showLoader:true});
                fetch(url, {
                    method: 'get',
                    mode: 'cors',
                    headers: {
                        'X-AUTH-TOKEN': this.props.authentication.jwtToken
                    }
                })
                    .then(response => response.json())
                    .then(json => {
                        console.log("Deleting Details");
                        console.log(json);
                        if (json && json.isError === false){
                            const {apiStatus}  = this.state;
                            apiStatus.isError = false;
                            apiStatus.message = json.message;
                            this.setState({ apiStatus: apiStatus})
                            console.log("apiStatus.message"+this.state.apiStatus.message);
                            this.setState({showLoader:false});
                        }else{
                            const {apiStatus}  = this.state;
                            apiStatus.isError = true;
                            apiStatus.message = json.message;
                            this.setState({disabledButton: true, apiStatus: apiStatus});
                            this.setState({showLoader:false});
                            if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                                this.props.onLogoutClick(json.message);
                            }
                        }

                    }).catch(error => {
                    console.log(error);
                    this.setState({showLoader:false});
                });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
            }
        })
    }
    componentDidMount() {
        this.fetchDashboard(1)
        if(this.props.params && this.props.params.value) {
            const {apiStatus} = this.state;
            apiStatus.isError = false;
            apiStatus.message = this.props.params.value;
            this.setState({apiStatus: apiStatus});
        }
    }
    handleKeyPress(id,e) {
        if (!e.shiftKey){
            const domForm = ReactDOM.findDOMNode(e).getElementsByClassName(id);
            const domFormSubmit = domForm.item(0);
            console.log(domFormSubmit);
            if(domFormSubmit){
                domFormSubmit.submit()
            }
        }
    }
    handleDeleteSignature(eSignatureId,status, pageNumber, count){
        console.log("Inside handleDeleteSignatureId "+eSignatureId);
        let url = this.props.api+'/signature/'+eSignatureId+'?status='+status+'&offset='+pageNumber+'&max='+count;
        console.log("url--- "+url);
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this E-Signature Request!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
        }).then((result) => {
            if (result.value) {
                this.setState({showLoader:true});
                fetch(url, {
                    method: 'delete',
                    mode: 'cors',
                    headers: {
                        'X-AUTH-TOKEN': this.props.jwtToken
                    }
                })
                    .then(response => response.json())
                    .then(json => {
                        console.log("Deleting Details");
                        console.log(json);
                        if (json && json.isError === false){
                            const {apiStatus}  = this.state;
                            apiStatus.isError = false;
                            apiStatus.message = json.message;
                            this.setState({ apiStatus: apiStatus})
                            console.log("apiStatus.message"+this.state.apiStatus.message);
                            this.fetchAllSignatureTemplate(json.pageNumber);
                            this.setState({showLoader:false});
                        }else{
                            const {apiStatus}  = this.state;
                            apiStatus.isError = true;
                            apiStatus.message = json.message;
                            this.setState({disabledButton: true, apiStatus: apiStatus});
                            this.setState({showLoader:false});
                            if (json.timeOut === true && json.httpCode === 401 && json.isError === true) {
                                this.props.onLogoutClick(json.message);
                            }
                        }

                    }).catch(error => {
                    this.setState({showLoader:false})
                    console.log(error);
                });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
            }
        })

    }
    refreshPageData(event) {
        this.setState({list: []});
        this.setState({search: ''});
        this.setState({baseUserList: []});
        this.setState({ statusList: ["SIGNED", "PENDING", "PROCESSING","DRAFT", "CANCELLED"]});
        this.setState({status: ''});
        this.setState({baseUser: ''});
        this.setState({createdFrom:null});
        this.setState({createdTo: null});
        this.setState({lastUpdatedFrom: null});
        this.setState({startDateTwo: null});
        this.setState({lastUpdatedTo: null});
        this.setState({sentFrom: null});
        this.setState({sentToRecipient: null});
        this.setState({formatCreatedFrom: null});
        this.setState({formatCreatedTo: null});
        this.setState({formatLastUpdatedFrom: null});
        this.setState({formatLastUpdatedTo: null});
        this.setState({formatSentFrom: null});
        this.setState({formatSentToRecipient: null});
        this.setState({emailTitle: ''});
        this.setState({activeNumber:1});
        this.setState({count:0});
        this.setState({rediretPage: ''});
        this.setState({    apiStatus: {
                isError: false,
                message: ''
            }});
        this.setState({showLoader:false});
        this.setState({shown: false})
        this.componentDidMount()
    }
    clearAllFilters(event){
        this.setState({status: ''});
        this.setState({baseUser: ''});
        this.setState({sentFrom:null})
        this.setState({sentToRecipient:null})
        this.setState({createdFrom:null});
        this.setState({createdTo: null});
        this.setState({lastUpdatedFrom: null});
        this.setState({startDateTwo: null});
        this.setState({lastUpdatedTo: null});
        this.setState({emailTitle: ''});
        this.setState({formatCreatedFrom: null});
        this.setState({formatCreatedTo: null});
        this.setState({formatLastUpdatedFrom: null});
        this.setState({formatLastUpdatedTo: null});
        this.setState({formatSentFrom: null});
        this.setState({formatSentToRecipient: null});
    }
    render() {
        const user = this.props.user;
        let _this = this;
        return (
            <div className="wrapper animated fadeInRight">
                <div className="row vcenter">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 heading-wrap vcenter">
                        <div className="col-md-5 col-sm-5 col-xs-12 no-gutters">
                            <h2 className="welcome-text">{_this.props.msg('topNavigation.welcome', {name : user && user.fullName})}</h2>
                        </div>
                        <div className="col-md-7 col-sm-7 col-xs-12  text-right upload-wrapper request-wrapper no-gutters">
                            <form className="req-doc m-r-xs" action={_this.props.backEndServerUrl+'/login/authenticateByToken'} method="post">
                                <input type="hidden" name="token" value={this.props.jwtToken} />
                                <input type="hidden" name="pageUrl" value="/esignature/getSignature" />
                                <input type="hidden" name="erpRequest" value="true" />
                                <input type="submit" value="Request Signature (Doc Upload)"
                                       name="Request Signature (Doc Upload)"/>
                            </form>
                            <div className="req-template">
                                <Link to="/template/list" className="btn btn-md btn-primary">Request Signature (Template)</Link>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12 ">
                        <InvalidAccessOrLogin jwtToken={this.props.jwtToken}
                                              redirectToForbiddenPage={this.state.redirectToForbiddenPage}/>
                        {this.state.showLoader === true ? (<div className="loading">Loading&#8230;</div>) : ''}
                        <div className="dashboard-table-wrap">
                            <div className="heading-wrapper clearfix">
                                <p className="m-t-xs">Signatures</p>
                                <div className="pull-right text-right">
                                    <div className="pull-right text-right">
                                        <div className="search-wrap">
                                            <input type="text"
                                                   placeholder="Search by recipient name/email or subject (Min 3 Char)"
                                                   className="input-sm form-control"
                                                   onChange={this.handleSearch.bind(this)} value={this.state.search}
                                                   name="search" size="60"/>
                                            <button type="button" className="btn btn-sm btn-primary">Search</button>
                                        </div>
                                        <button type="button" className="btn btn-white btn-sm m-l-xs"
                                                data-toggle="modal"
                                                data-target="#filterModal"><i className="fa fa-filter"></i> Filters
                                        </button>
                                        <div className="search-wrap" style={{marginLeft: "10px"}}>
                                            <button type="button" className="btn btn-white btn-sm"
                                                    onClick={this.refreshPageData.bind(this)}>Refresh
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="table-box table-responsive p-m">
                                <div style={{'textAlign':'center'}}>
                                    <Errors errorObject={this.state.apiStatus}/>
                                    <br/>
                                </div>
                                <table className="table table-condensed-xs">
                                    <thead>
                                    <tr>
                                        <th className="header text-left">{_this.props.msg('table.th.title')}</th>
                                        {(this.state.blubillingConf && this.state.blubillingConf.enablePayments === true) ? (<th className="header text-right">{_this.props.msg('table.th.paymentAmount')}</th>) : null}
                                        {(this.state.blubillingConf && this.state.blubillingConf.enablePayments === true) ? (<th className="header text-center">{_this.props.msg('table.th.paymentDate')}</th>) : null}
                                        {(this.state.blubillingConf && this.state.blubillingConf.enablePayments === true) ? (<th className="header text-center">{_this.props.msg('table.th.paymentStatus')}</th>) : null}
                                        <th className="header text-left">{_this.props.msg('table.th.sent')}</th>
                                        <th className="header text-left">{_this.props.msg('table.th.recipients')}</th>
                                        <th className="header text-left" style={{whiteSpace:'nowrap'}}>{_this.props.msg('table.th.signatureRequesterName')}</th>
                                        {(this.state.blubillingConf && this.state.blubillingConf.username && this.state.blubillingConf.disabled !== true) ? (<th className="header text-left">{_this.props.msg('table.th.blubillingCustomer')}</th>) : null}
                                        <th className="header text-left">{_this.props.msg('table.th.status')}</th>
                                        <th className="header text-left" style={{width:"16%"}}>{_this.props.msg('table.th.action')}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.list && this.state.list.map(function(signatureRequest, index) {
                                        return (
                                            <tr key={Math.random()}>
                                                <td className="text-left">
                                                    <Link to={'/esignatureDetail/'+signatureRequest.id} title="View Signature Request" style={{textDecoration:"underline"}}>
                                                        {signatureRequest.emailTitle}
                                                    </Link>
                                                </td>
                                                {(_this.state.blubillingConf && _this.state.blubillingConf.enablePayments === true) ? (
                                                    <td className="text-right">
                                                        {signatureRequest.paymentInstance && signatureRequest.paymentInstance.amount ?
                                                            <Link
                                                                to={'/payment/detail/' + signatureRequest.paymentInstance.id}
                                                                target="_blank" title="View Payment"
                                                                style={{textDecoration: "underline"}}>
                                                                $ {Util.formatMoney(signatureRequest.paymentInstance.amount ? signatureRequest.paymentInstance.amount : null)}
                                                            </Link> : ""}
                                                    </td>) : null}

                                                {(_this.state.blubillingConf && _this.state.blubillingConf.enablePayments === true) ? (
                                                    <td className="text-center">
                                                        {signatureRequest.paymentInstance && signatureRequest.paymentInstance.effectiveDate ?
                                                            moment(signatureRequest.paymentInstance.effectiveDate).format("MM/DD/YYYY") : ""}
                                                    </td>) : null}

                                                {(_this.state.blubillingConf && _this.state.blubillingConf.enablePayments === true) ? (
                                                    <td className="text-center">
                                                        {signatureRequest.paymentInstance && signatureRequest.paymentInstance.status === "PAID" ?
                                                            <span
                                                                className="label label-success text-uppercase label-fixed">PAID</span>
                                                            :null}
                                                        {signatureRequest.paymentInstance && signatureRequest.paymentInstance.status === "DRAFT" ?
                                                            <span
                                                                className="label label-info text-uppercase label-fixed">DRAFT</span>
                                                            :null}

                                                        {signatureRequest.paymentInstance && signatureRequest.paymentInstance.status === "DECLINED" ?
                                                            <span
                                                                className="label label-warning text-uppercase label-fixed">DECLINED</span>
                                                            :null}

                                                        {signatureRequest.paymentInstance && signatureRequest.paymentInstance.status === "ERROR" ?
                                                            <span
                                                                className="label label-danger text-uppercase label-fixed">ERROR</span>
                                                            :null}

                                                        {signatureRequest.paymentInstance && signatureRequest.paymentInstance.status === "VOIDED" ?
                                                            <span
                                                                className="label label-draft text-uppercase label-fixed">VOIDED</span>
                                                            :null}

                                                        {signatureRequest.paymentInstance && signatureRequest.paymentInstance.status === "REVERSED" ?
                                                            <span
                                                                className="label label-default text-uppercase label-fixed">REVERSED</span>
                                                            :null}
                                                    </td>) : null}
                                                <td className="text-left" style={{"width":"7%"}}>{signatureRequest.sentDate?moment(signatureRequest.sentDate).format("MM/DD/YYYY hh:mm:ss"):'Not yet sent'}</td>
                                                <td className="text-left">{
                                                    signatureRequest.recipients.map(function(recipient){
                                                        return <p key={Math.random()}>{recipient.name}<span style={{"fontSize":"10px"}}> ({recipient.status})</span></p>
                                                    })
                                                }</td>
                                                <td className="text-left" style={{whiteSpace: 'nowrap'}}>
                                                    {signatureRequest.requesterName}
                                                </td>
                                                {(_this.state.blubillingConf &&  _this.state.blubillingConf.username && _this.state.blubillingConf.disabled !== true) ? (<td style={{"width":"15%"}}>
                                                    <div style={{fontSize:"12px"}}>
                                                        <p><strong>{(signatureRequest.blubillingCustomer && signatureRequest.blubillingCustomer.companyName)?signatureRequest.blubillingCustomer.companyName:null}</strong></p>
                                                        {(signatureRequest.blubillingCustomer && signatureRequest.blubillingCustomer.firstName)?<p>{signatureRequest.blubillingCustomer.firstName}&nbsp;{(signatureRequest.blubillingCustomer && signatureRequest.blubillingCustomer.lastName)?signatureRequest.blubillingCustomer.lastName:null}</p>:null}
                                                        <p>{(signatureRequest.blubillingCustomer && signatureRequest.blubillingCustomer.email)?signatureRequest.blubillingCustomer.email:null}</p>
                                                    </div>
                                                </td>) : null}
                                                <td className="text-left ">
                                                    {signatureRequest.status === "SIGNED"?
                                                        <span
                                                            className="label label-green text-uppercase label-fixed">SIGNED</span>
                                                        :null}
                                                    {signatureRequest.status === "PROCESSING"?
                                                        <span
                                                            className="label label-warning text-uppercase label-fixed">PROCESSING</span>
                                                        :null}
                                                    {signatureRequest.status === "PENDING"?
                                                        <span
                                                            className="label label-pending text-uppercase label-fixed">PENDING</span>
                                                        :null}
                                                    {signatureRequest.status === "DRAFT"?
                                                        <span className="label label-info text-uppercase label-fixed">DRAFT</span>
                                                        :null}
                                                    {signatureRequest.status === "CANCELLED"?
                                                        <span
                                                            className="label label-grey text-uppercase label-fixed">CANCELLED</span>
                                                        :null}
                                                </td>
                                                <td className="text-left">
                                                    {signatureRequest.status === "DRAFT" ?
                                                        <form ref="form" style={{display:'inline-block'}}
                                                              className={'m-r-xxs '+signatureRequest.id}
                                                              action={_this.props.backEndServerUrl+'/login/authenticateByToken'} method="post" >
                                                            <input type="hidden" name="token" value={_this.props.jwtToken} />
                                                            <input type="hidden" name="pageUrl" value={"/esignature/esignatureRequestEdit?id="+signatureRequest.id}/>
                                                            <input type="hidden" name="erpRequest" value="true" />
                                                            <button type="button" onClick={(e)=>_this.handleKeyPress(signatureRequest.id,_this)}
                                                                    title="Edit Signature Request" className={'btn btn-white btn-sm '}
                                                                    ><i
                                                                className="fa fa-edit"></i> <span
                                                                className="hidden-xs hidden-sm">Edit</span></button>
                                                        </form>
                                                        :null}
                                                    {signatureRequest.status === "DRAFT"?
                                                        <button onClick={(e)=>_this.handleDeleteSignature(signatureRequest.id,signatureRequest.status, _this.state.activeNumber, _this.state.count)}
                                                                title="Delete Signature Request"  type="button" className="btn btn-white btn-sm m-r-xxs"><i
                                                            className="fa fa-trash"></i> <span
                                                            className="hidden-xs hidden-sm">Delete</span>
                                                        </button>
                                                        :null}
                                                    {signatureRequest.status !== "SIGNED" && signatureRequest.status !== "CANCELLED"?
                                                        <button type="button" className="btn btn-white btn-sm"
                                                                onClick={(e)=>_this.handleResendEmail(signatureRequest.id)}
                                                                title="Re-Send to all Un-Signed Recipient">
                                                            <i className="fa fa-paper-plane"></i> <span
                                                            className="hidden-xs hidden-sm">Re-send</span>
                                                        </button>
                                                        :null}

                                                    {signatureRequest.status === "SIGNED" && signatureRequest.status !== "CANCELLED"?
                                                        <Link to={'/esignatureDetail/'+signatureRequest.id}>
                                                            <button type="button" className="btn btn-white btn-sm"
                                                                    title="View Signature Request">
                                                                <i className="fa fa-book"></i> <span
                                                                className="hidden-xs hidden-sm">View</span>
                                                            </button>
                                                        </Link>

                                                        :null}


                                                    {/*<button type="button" className="btn btn-white btn-sm"><i
                                                        className="fa fa-edit"></i> <span
                                                        className="hidden-xs hidden-sm">Edit</span></button>
                                                    <button type="button" className="btn btn-white btn-sm"><i
                                                        className="fa fa-trash"></i> <span
                                                        className="hidden-xs hidden-sm">Delete</span></button>*/}

                                                </td>
                                            </tr>
                                        )
                                    })}
                                    </tbody>
                                    <tfoot>
                                    <tr>
                                        <td colSpan="6" className="footable-visible">
                                                <Pagination
                                                    activePage={this.state.activeNumber}
                                                    itemsCountPerPage={this.state.limit}
                                                    totalItemsCount={this.state.count}
                                                    pageRangeDisplayed={5}
                                                    onChange={this.fetchAllSignatureTemplate}
                                                />
                                        </td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div className="modal" id="filterModal" role="dialog">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <div className="pull-right">
                                                {/*<a href="" className="help m-r-xs"><i className="fa fa-question-circle"
                                                                                      aria-hidden="true"></i> </a>*/}
                                                <a className="close-btn" data-dismiss="modal">
                                                    <i className="fa fa-times" aria-hidden="true"></i>
                                                </a>
                                            </div>
                                            <h4 className="modal-title">Apply Filters</h4>

                                        </div>
                                        <div className="modal-body">
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-gutters m-b-sm">
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                        <label htmlFor="exampleFormControlSelect1">Status Type</label>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 padd-left-no">
                                                        <select className="form-control" name ="status" id="status"
                                                                onChange={this.handleChange} value={this.state.status}>
                                                            <option value = "">Select status</option>
                                                            {this.state.statusList && this.state.statusList.map(function(status, index){
                                                                return (
                                                                    <option key={ Math.random()} value={status}>{status}</option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-gutters m-b-sm">
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                        <label htmlFor="exampleFormControlSelect1">Created by</label>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 padd-left-no">
                                                        {(this.state.loggedInUser &&  this.state.loggedInUser.roles &&
                                                            this.state.loggedInUser.roles.some(v => (v === "ROLE_ADMIN" || v === "ROLE_SYSTEM_SUPPORT" || v === "ROLE_MANAGER"))) ?
                                                            <select className="form-control" name="baseUser" id="baseUser"
                                                                    onChange={this.handleChange}
                                                                    value={this.state.baseUser}>
                                                                <option value="">Select User</option>
                                                                {this.state.baseUserList && this.state.baseUserList.map(function (baseUser, index) {
                                                                    return (
                                                                        <option key={Math.random()}
                                                                                value={baseUser.id}>{baseUser.firstName} {baseUser.lastName}</option>
                                                                    );
                                                                })}
                                                            </select>:
                                                            <select className="form-control" name="baseUser" id="baseUser"
                                                                    value={this.state.loggedInUser.id} disabled="disabled">
                                                                {this.state.loggedInUser ?
                                                                    <option key={Math.random()}
                                                                            value={this.state.loggedInUser.id}>{this.state.loggedInUser.fullName}</option>
                                                                    : ''
                                                                }
                                                            </select>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-gutters m-b-sm">
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                        <label htmlFor="exampleFormControlSelect1">Sent From</label>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 padd-left-no">
                                                        {/*<div className="form-group">*/}
                                                            <div className="input-group date">
                                                                <span className="input-group-addon"><i
                                                                    className="fa fa-calendar"></i></span>

                                                                <DatePicker className="form-control" autoComplete = "off"
                                                                            name="sentFrom" id="sentFrom"
                                                                            selected={this.state.sentFrom}
                                                                            onChange={this.handleChangeDatePicker.bind(this,'sentFrom', 'formatSentFrom')}
                                                                             />
                                                            </div>
                                                        {/*</div>*/}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-gutters m-b-sm">
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                        <label htmlFor="exampleFormControlSelect1">Sent to</label>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 padd-left-no">
                                                        {/*<div className="form-group">*/}
                                                            <div className="input-group date">
                                                                <span className="input-group-addon">
                                                                    <i className="fa fa-calendar"></i>
                                                                </span>
                                                                <DatePicker className="form-control datepick" autoComplete = "off"
                                                                            name="sentToRecipient" id="sentToRecipient"
                                                                            onChange={this.handleChangeDatePicker.bind(this,'sentToRecipient', 'formatSentToRecipient')}
                                                                            selected={this.state.sentToRecipient} />
                                                            </div>
                                                        {/*</div>*/}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-gutters m-b-sm">
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                        <label htmlFor="exampleFormControlSelect1">Start
                                                            Date</label>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 padd-left-no">
                                                        {/*<div className="form-group">*/}
                                                            <div className="input-group date">
                                                                <span className="input-group-addon"><i
                                                                    className="fa fa-calendar"></i></span>
                                                                <DatePicker className="form-control datepick" autoComplete = "off"
                                                                            name="createdFrom" id="createdFrom"
                                                                            onChange={this.handleChangeDatePicker.bind(this,'createdFrom', 'formatCreatedFrom')}
                                                                            selected={this.state.createdFrom}/>
                                                            </div>
                                                        {/*</div>*/}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-gutters m-b-sm">
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                        <label htmlFor="exampleFormControlSelect1">End Date</label>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 padd-left-no">
                                                        {/*<div className="form-group">*/}
                                                            <div className="input-group date">
                                                                <span className="input-group-addon"><i
                                                                    className="fa fa-calendar"></i></span>
                                                                <DatePicker className="form-control datepick" autoComplete = "off"
                                                                            name="createdTo" id="createdTo"
                                                                            onChange={this.handleChangeDatePicker.bind(this,'createdTo', 'formatCreatedTo')}
                                                                            selected={this.state.createdTo}/>
                                                            </div>
                                                        {/*</div>*/}
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-gutters m-b-sm">
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                        <label htmlFor="exampleFormControlSelect1">Last Updated
                                                            From</label>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 padd-left-no">
                                                        {/*<div className="form-group">*/}
                                                           <div className="input-group date">
                                                                <span className="input-group-addon">
                                                                    <i className="fa fa-calendar"></i>
                                                                </span>
                                                               <DatePicker className="form-control datepick" autoComplete = "off"
                                                                           name="lastUpdatedFrom" id="lastUpdatedFrom"
                                                                           onChange={this.handleChangeDatePicker.bind(this,'lastUpdatedFrom', 'formatLastUpdatedFrom')}
                                                                           selected={this.state.lastUpdatedFrom} />
                                                            </div>
                                                        {/*</div>*/}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 no-gutters m-b-sm">
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                        <label htmlFor="exampleFormControlSelect1">Last Updated
                                                            To</label>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 padd-left-no">
                                                        {/*<div className="form-group">*/}
                                                            <div className="input-group date">
                                                                <span className="input-group-addon">
                                                                    <i className="fa fa-calendar"></i>
                                                                </span>
                                                                <DatePicker className="form-control datepick" autoComplete = "off"
                                                                            name="lastUpdatedTo" id="lastUpdatedTo"
                                                                            onChange={this.handleChangeDatePicker.bind(this,'lastUpdatedTo', 'formatLastUpdatedTo')}
                                                                            selected={this.state.lastUpdatedTo} />
                                                            </div>
                                                        {/*</div>*/}
                                                    </div>
                                                </div>
                                                <div
                                                    className="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 no-gutters">
                                                    <div className="col-lg-3 col-lg-3 col-md-3 col-sm-3 col-xs-6">
                                                        <label htmlFor="exampleFormControlSelect1">Email Subject</label>
                                                    </div>
                                                    <div
                                                        className="col-lg-9 col-lg-9 col-md-9 col-sm-9 col-xs-6 padd-left-no">
                                                        <input type='text' className="form-control"
                                                               name="emailTitle"
                                                               id="emailTitle"
                                                               onChange={this.handleChange}
                                                               value={this.state.emailTitle}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-white btn-sm pull-left"
                                                    onClick={(e)=>this.clearAllFilters(e)}>Clear All
                                            </button>
                                            <div className="pull-right">
                                                <button type="button" className="btn btn-white btn-sm"
                                                        data-dismiss="modal">Cancel
                                                </button>
                                                <button type="button" className="btn btn-sm btn-primary"
                                                        data-dismiss="modal" onClick={(e)=>_this.fetchAllSignatureTemplate(1)}>Apply
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js